<app-schema-jsonld [id]="'jsonld-job'" [schema]="schema"></app-schema-jsonld>

<!-- Franchise partner layout -->
<section class="darksection py-5" *ngIf="data?.position == 'Franchise Partner'">
	<div class="container-fluid">
		<div class="row justify-content-center">
			<div class="col-md-9">
				<!-- Top header: logo + title -->
				<div class="card bg-white mb-4">
					<div class="card-header py-4">
						<div class="row">
							<div class="col-sm-4 col-md-2 col-3 mb-md-0 mb-3">
								<div
									class="d-flex justify-content-center align-items-center logo-container rounded-4 border overflow-hidden"
									style="aspect-ratio: 1;" [style.background]="dominantColor">
										<img class="w-100" [src]="data?.company_logo_url" alt="Company Logo" />
								</div>
							</div>
							<div class="col-sm-4 col-md-8 col-6 mb-md-0 mb-3">
								<h2 class="mb-1 fw-bold">{{ data.position }}</h2>
								<div class="d-flex align-items-top mb-0">
									<p class="h5 text-muted">{{ data.company_name }}</p>
									<span class="ms-1 text-primary"><i class="fas fa-badge-check"></i></span>
								</div>
							</div>
							<div class="col-sm-6 col-md-2 col-3 mb-md-0 mb-3">
								<div class="d-flex justify-content-end gap-3">
									<a type="button" class="btn primary-btn w-100" href="https://shorturl.at/bFaAv"
										target="_blank" rel="noopener noreferrer">
										Apply Now
									</a>
								</div>
							</div>
						</div>
						<div class="card-body">
							<div class="row g-3">
								<!-- <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
								                    <div class="d-flex gap-2 text-left align-items-center">
								                      <i class="fas fa-users me-2 mt-1 color-gray"></i>
								                      <div>
								                        <p class="text-small text-muted mb-1">Experience Level</p>
								                        <p class="fw-bold mb-0">{{ data.experience_level }}</p>
								                      </div>
								                    </div>
								                  </div> -->
								<div class="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-4 col-6">
									<div class="d-flex gap-2 text-left align-items-center">
										<i class="fas fa-briefcase fa-lg me-2 mt-1 color-darkblue"></i>
										<div>
											<p class="text-small text-muted mb-1">Experience Level</p>
											<p class="fw-bold mb-0">{{ data.experience_level }}</p>
										</div>
									</div>
									<!-- <div class="d-flex gap-2 text-left align-items-center">
										<i class="fas fa-calendar me-2 mt-1 color-purple"></i>
										<div>
											<p class="text-small text-muted mb-1">Start Date</p>
											<p class="fw-bold mb-0">{{ data.start_date }}</p>
										</div>
									</div> -->
								</div>
								<div class="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-4 col-6">
									<div class="d-flex gap-2 text-left align-items-center">
										<i class="fas fa-user-graduate fa-lg me-2 mt-1 color-darkblue"></i>
										<div>
											<p class="text-small text-muted mb-1">Minimum Educational Requirement</p>
											<p class="fw-bold mb-0">{{ data.minimum_education }}</p>
										</div>
									</div>
								</div>
								<div class="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-4 col-6">
									<div class="d-flex gap-2 text-left align-items-center">
										<i class="fas fa fa-transgender-alt fa-lg	me-2 mt-1 color-darkblue"></i>
										<div>
											<p class="text-small text-muted mb-1">Gender Requirement</p>
											<p class="fw-bold mb-0">Any</p>
										</div>
									</div>
								</div>
								<div class="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-4 col-6">
									<div class="d-flex gap-2 text-left align-items-center">
										<i class="fas fa fa-dollar-sign fa-lg	me-2 mt-1 color-darkblue"></i>
										<div>
											<p class="text-small text-muted mb-1">Revenue Sharing</p>
											<p class="fw-bold mb-0">50%</p>
										</div>
									</div>
								</div>
								<!-- <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
									<div class="d-flex gap-2 text-left align-items-center">
										<i class="fas fa-hourglass me-2 mt-1 color-red"></i>
										<div>
											<p class="text-small text-muted mb-1">Deadline</p>
											<p class="fw-bold mb-0">{{ data.due_date }}</p>
										</div>
									</div>
								</div>
								<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
									<div class="d-flex gap-2 text-left align-items-center">
										<i class="fas fa-location-dot me-2 mt-1 color-green"></i>
										<div>
											<p class="text-small text-muted mb-1">Location</p>
											<p class="fw-bold mb-0">{{ data.work_location }}</p>
										</div>
									</div>
								</div>
								<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
									<div class="d-flex gap-2 text-left align-items-center">
										<i class="fas fa-car-building me-2 mt-1 color-orange"></i>
										<div>
											<p class="text-small text-muted mb-1">Work Mode</p>
											<p class="fw-bold mb-0" *ngIf="data?.work_mode?.length">
												{{ data.work_mode.join(", ") }}
											</p>
										</div>
									</div>
								</div>
								<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
									<div class="d-flex gap-2 text-left align-items-center">
										<i class="fas fa-person-walking-luggage me-2 mt-1 color-red"></i>
										<div>
											<p class="text-small text-muted mb-1">Work Type</p>
											<p class="fw-bold mb-0">{{ data.employment_type }}</p>
										</div>
									</div>
								</div>
								<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
									<div class="d-flex gap-2 text-left align-items-center">
										<i class="fas fa-dollar me-2 mt-1 color-green"></i>
										<div>
											<p class="text-small text-muted mb-1">Salary / Month</p>
											<p class="fw-bold mb-0">
												{{ data.salary_offer | number: "1.0-0" }} -
												{{ getSalaryUpperBound(data.salary_offer) | number: "1.0-0" }}
												{{ data.currency_code }}
											</p>
										</div>
									</div>
								</div>

								<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
									<div class="d-flex gap-2 text-left align-items-center">
										<i class="fas fa-user-graduate me-2 mt-1 color-darkblue"></i>
										<div>
											<p class="text-small text-muted mb-1">Educational Degree</p>
											<p class="fw-bold mb-0">{{ data.minimum_education }}</p>
										</div>
									</div>
								</div> -->
								<!-- <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6" *ngIf=" data.department">
									<div class="d-flex gap-2 text-left align-items-center">
										<i class="fa fa-industry me-2 mt-1 color-purple"></i>
										<div>
											<p class="text-small text-muted mb-1">Industry</p>
											<p class="fw-bold mb-0">{{ data.department }}</p>
										</div>
									</div>
								</div> -->
							</div>
						</div>
					</div>
				</div>

				<!-- Key Responsibilities card (screenshot area) -->
				<div class="card bg-white mb-4">
					<div class="card-body">
						<div class="row">
							<div class="col-md-3">
								<h3 class="fw-bold">Key Responsibilities</h3>
							</div>
							<div class="col-md-9">
								<p class="overview-description" [innerHTML]="data.key_responsibilities"></p>
							</div>
						</div>
					</div>
				</div>

				<!-- Key Benefits card (screenshot area) -->
				<div class="col-md-12">
					<div class="card  bg-white">
						<div class="card-body">
							<div class="row">
								<div class="col-md-3">
									<h3 class="fw-bold">Key Benefits</h3>
								</div>
								<div class="col-md-9">
									<div class="d-flex flex-wrap gap-2">
										<ul>
											<li>Zero Investment beyond setup</li>
											<li>No Regional Partner Fees</li>
											<li>50% Revenue Share</li>
											<li>7-Day Instant Revenue Settlement</li>
											<li>Exclusive City Rights</li>
											<li>Training & Speaker Support</li>
											<li>High ROI Potential</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</section>
<!-- Standard job layout -->
<section class="darksection py-5" *ngIf="data && data.position != 'Franchise Partner'">
	<div class="container-fluid">
		<div class="row justify-content-center">
			<div class="col-md-9">
				<div class="row g-3">
					<div class="col-md-12">
						<div class="card bg-white">
							<div class="card-header py-4">
								<div class="row">
									<div class="col-md-2 col-4 mb-md-0 mb-3">
										<div
											class="d-flex justify-content-center align-items-center logo-container rounded-4 border overflow-hidden"
											style="aspect-ratio: 1;" [style.background]="dominantColor">
											<img class="w-100" [src]="data?.company_logo_url" alt="Company Logo" />
										</div>
									</div>
									<div class="col-md-10 col-12">
										<div class="row mb-3">
											<div class="col-md-9">
												<h2 class="mb-1 fw-bold">{{ data.position }}</h2>
												<div class="d-flex align-items-top mb-0">
													<p class="h5 text-muted">{{ data.company_name }}</p>
													<span class="ms-1 text-primary">
														<i class="fas fa-badge-check"></i>
													</span>
												</div>
												<!-- <p class="text-muted text-small">
                          Job id: <strong>{{ data.job_id }}</strong>
                        </p> -->
											</div>
											<div class="col-md-3">
												<div class="d-flex justify-content-end gap-3">
													<!-- Apply is kept as a plain anchor to avoid SSR issues with client-only button directives. -->
													<a type="button" class="btn primary-btn w-100" [href]="getRegisterLink(ifExist, data)"
														target="_blank" rel="noopener noreferrer">
														Apply Now
													</a>
												</div>
											</div>
										</div>
										<div class="row align-items-center">
											<div class="col-md-12">
												<div class="d-flex gap-3 align-items-center">
													<div class="">
														<div class="d-flex gap-2 text-left align-items-center">
															<i class="fas fa-user-magnifying-glass me-2 mt-1 color-black"></i>
															<div>
																<p class="text-muted text-small mb-1">Available
																	Vacancies</p>
																<p class="fw-bold h3 mb-0">{{ data.available_vacancies
																	}}</p>
															</div>
														</div>
													</div>
													<div class="d-none">
														<div class="d-flex gap-2 text-left align-items-center">
															<i class="fas fa-user-tie me-2 mt-1 color-orange"></i>
															<div>
																<p class="text-muted text-small mb-1">Total Applied</p>
																<p class="fw-bold h3 mb-0">{{ data.total_applied }}</p>
															</div>
														</div>
													</div>
													<div class="d-none">
														<div class="d-flex gap-2 text-left align-items-center">
															<i class="fas fa-video me-2 mt-1 color-gray"></i>
															<div>
																<p class="text-muted text-small mb-1">Introduction Video
																</p>
																<p class="fw-bold mb-0">{{ data.intro_video === 1 ?
																	"Mandatory" : "Not Mandatory" }}</p>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="card-body">
								<div class="row g-3">
									<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6"
										*ngIf="!isUniprep">
										<div class="d-flex gap-2 text-left align-items-center">
											<i class="fas fa-calendar me-2 mt-1 color-purple"></i>
											<div>
												<p class="text-small text-muted mb-1">Start Date</p>
												<p class="fw-bold mb-0">{{ data.start_date }}</p>
											</div>
										</div>
									</div>
									<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 d-none"
										*ngIf="!isUniprep">
										<div class="d-flex gap-2 text-left align-items-center">
											<i class="fas fa-hourglass me-2 mt-1 color-red"></i>
											<div>
												<p class="text-small text-muted mb-1">Deadline</p>
												<p class="fw-bold mb-0">{{ data.due_date }}</p>
											</div>
										</div>
									</div>
									<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
										<div class="d-flex gap-2 text-left align-items-center">
											<i class="fas fa-location-dot me-2 mt-1 color-green"></i>
											<div>
												<p class="text-small text-muted mb-1">Location</p>
												<p class="fw-bold mb-0">{{ data.work_location }}</p>
											</div>
										</div>
									</div>
									<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
										<div class="d-flex gap-2 text-left align-items-center">
											<i class="fas fa-car-building me-2 mt-1 color-orange"></i>
											<div>
												<p class="text-small text-muted mb-1">Work Mode</p>
												<p class="fw-bold mb-0" *ngIf="data?.work_mode?.length">
													{{ data.work_mode.join(", ") }}
												</p>
											</div>
										</div>
									</div>
									<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
										<div class="d-flex gap-2 text-left align-items-center">
											<i class="fas fa-person-walking-luggage me-2 mt-1 color-red"></i>
											<div>
												<p class="text-small text-muted mb-1">Work Type</p>
												<p class="fw-bold mb-0">{{ data.employment_type }}</p>
											</div>
										</div>
									</div>
									<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
										<div class="d-flex gap-2 text-left align-items-center">
											<i class="fas fa-dollar me-2 mt-1 color-green"></i>
											<div>
												<p class="text-small text-muted mb-1">Salary / Month</p>
												<p class="fw-bold mb-0">
													{{ data.salary_offer | number: "1.0-0" }} -
													{{ getSalaryUpperBound(data.salary_offer) | number: "1.0-0" }}
													{{ data.currency_code }}
												</p>
											</div>
										</div>
									</div>
									<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
										<div class="d-flex gap-2 text-left align-items-center">
											<i class="fas fa-briefcase me-2 mt-1 color-black"></i>
											<div>
												<p class="text-small text-muted mb-1">Experience Level</p>
												<p class="fw-bold mb-0">{{ data.experience_level }}</p>
											</div>
										</div>
									</div>
									<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6">
										<div class="d-flex gap-2 text-left align-items-center">
											<i class="fas fa-user-graduate me-2 mt-1 color-darkblue"></i>
											<div>
												<p class="text-small text-muted mb-1">Educational Degree</p>
												<p class="fw-bold mb-0">{{ data.minimum_education }}</p>
											</div>
										</div>
									</div>
									<div class="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6" *ngIf=" data.department">
										<div class="d-flex gap-2 text-left align-items-center">
											<i class="fa fa-industry me-2 mt-1 color-purple"></i>
											<div>
												<p class="text-small text-muted mb-1">Industry</p>
												<p class="fw-bold mb-0">{{ data.department }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="col-md-12">
						<div class="card bg-white">
							<div class="card-body">
								<div class="row">
									<div class="col-md-3">
										<h3 class="fw-bold">Job Overview</h3>
									</div>
									<div class="col-md-9">
										<p class="overview-description" [innerHTML]="data.job_overview"></p>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="col-md-12">
						<div class="card  bg-white">
							<div class="card-body">
								<div class="row">
									<div class="col-md-3">
										<h3 class="fw-bold">Key Responsibilities</h3>
									</div>
									<div class="col-md-9">
										<p class="overview-description" [innerHTML]="data.key_responsibilities"></p>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="col-md-12">
						<div class="card  bg-white">
							<div class="card-body">
								<div class="row">
									<div class="col-md-3">
										<h3 class="fw-bold">Language Proficiency</h3>
									</div>
									<div class="col-md-9">
										<ul class="list-unstyled font-bold">
											<li *ngFor="let lang of data.languages" class="mb-3">
												<div class="d-flex align-items-center gap-2">
													<span class="me-2">{{ lang.lang }}</span>
													<p-rating *ngIf="lang.level" style="font-size: large"
														[ngModel]="getProficiencyRating(lang.level)" [readonly]="true"></p-rating>
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!--          <div class="col-md-12">-->
					<!--            <div class="card">-->
					<!--              <div class="card-body">-->
					<!--                <div class="row">-->
					<!--                  <div class="col-md-3">-->
					<!--                    <h3 class="fw-bold">Compensation Structure</h3>-->
					<!--                  </div>-->
					<!--                  <div class="col-md-9">-->
					<!--                    <div class="d-flex flex-wrap gap-2">-->
					<!--                      <span *ngFor="let resp of data.compensation_structure"-->
					<!--                        class="custom-badge">{{ resp }}</span>-->
					<!--                    </div>-->
					<!--                  </div>-->
					<!--                </div>-->
					<!--              </div>-->
					<!--            </div>-->
					<!--          </div>-->

					<div class="col-md-12" *ngIf="data.benefits_perks.length > 0">
						<div class="card  bg-white">
							<div class="card-body">
								<div class="row">
									<div class="col-md-3">
										<h3 class="fw-bold">Additional Benefits & Perks</h3>
									</div>
									<div class="col-md-9">
										<div class="d-flex flex-wrap gap-2">
											<span *ngFor="let benefit of data.benefits_perks" class="custom-badge">{{
												benefit }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="col-md-12" *ngIf="data.soft_skills.length > 0">
						<div class="card  bg-white">
							<div class="card-body">
								<div class="row">
									<div class="col-md-3">
										<h3 class="fw-bold">Essentials Soft Skills</h3>
									</div>
									<div class="col-md-9">
										<div class="d-flex flex-wrap gap-2">
											<span *ngFor="let skill of data.soft_skills" class="custom-badge">{{ skill
												}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="col-md-12 d-none">
						<div class="card  bg-white">
							<div class="card-body">
								<div class="row">
									<div class="col-md-3">
										<h3 class="fw-bold">Hiring & Recruitment</h3>
									</div>
									<div class="col-md-9">
										<div class="row">
											<div class="col-12 col-md-12 font-bold">
												<p class="mb-2 uniprep-primary fw-semibold" *ngIf="data.hiring_stages.length > 0">Hiring Process
													Stages</p>
												<div class="d-flex flex-wrap gap-2 mb-4" *ngIf="data.hiring_stages.length > 0">
													<span *ngFor="let stage of data.hiring_stages" class="custom-badge">{{ stage }}</span>
												</div>

												<p class="mb-2 uniprep-primary fw-semibold" *ngIf="data.hiring_timeframe">Estimated Hiring
													Decision
													Timeframe</p>
												<p *ngIf="data.hiring_timeframe" class="mb-4">{{ data.hiring_timeframe }}</p>

												<p class="mb-2 uniprep-primary fw-semibold" *ngIf="data.interview_format.length > 0">Interview
													Format</p>
												<div class="d-flex flex-wrap gap-2 mb-4" *ngIf="data.interview_format.length > 0">
													<span *ngFor="let stage of data.interview_format" class="custom-badge">
														{{ stage }}
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-12" *ngIf="data.additional_notes">
						<div class="card  bg-white">
							<div class="card-body">
								<div class="row">
									<div class="col-md-3">
										<h3 class="fw-bold">Additional Notes</h3>
									</div>
									<div class="col-md-9">
										<p class="overview-description" [innerHTML]="data.additional_notes"></p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
